import React from 'react';
import { Badge } from '@mui/material';

const AchievementBadge = ({ sx, ...props }) => (
  <Badge
    {...props}
    sx={{
      '& .MuiBadge-badge': {
        top: 20,
        right: 15,
        fontSize: '1rem',
        height: 28,
        minWidth: 30,
      },
      ...sx,
    }}
  />
);

export default AchievementBadge;
